import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router';
import { shallowEqual, useSelector } from 'react-redux';
import useAuth from 'src/hooks/useAuth';
import { RootState } from 'src/redux/rootReducerType';
import { HM_DASHBOARD } from 'src/routes/paths';
import LoadingScreen from 'src/components/LoadingScreen';

interface NewRenterExperienceGuardProps {
  children: ReactNode;
}

const NewRenterExperienceGuard: FC<NewRenterExperienceGuardProps> = ({
  children,
}) => {
  const { user, isInitialized } = useAuth();
  const isNewRentersExperienceEnabled = useSelector(
    (state: RootState) => state.featureFlags.flags.ENABLE_NEW_RENTER_EXPERIENCE,
    shallowEqual
  );

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  const canSeeNewExperience =
    isNewRentersExperienceEnabled && user?.sees_new_experience;

  if (!canSeeNewExperience) {
    return <Navigate to={HM_DASHBOARD.root} replace />;
  }

  return <>{children}</>;
};

export default NewRenterExperienceGuard;
